export default __webpack_public_path__ + "static/media/prosper.c7eeb9d7.png";